import React from 'react';
import { getCurrentDateTime } from '../utils/Utils';
import TextToSpeech from '../components/TextToSpeech'
import { useLocation } from 'react-router-dom';
import { observer } from "mobx-react-lite";
import LanguageSelector from './LanguageSelector';

const Banner = ({ customerInfo, labels }) => {
    const selfData = customerInfo?.GroupDetails?.Customers.filter(el => el.Number === customerInfo?.CustomerDetails?.Number);
    const customerName = selfData?.[0]?.Name;
    const customerImage = selfData?.[0]?.Thumbnail;
    const customerNumber = selfData?.[0]?.Number;
    const location = useLocation();

    if (!selfData) {
        return <div></div>
    }
    return (
        <>
            <div className="flex justify-between items-center sm:h-[6vh] md:h-[6vh] lg:h-[7vh] xl:h-[8vh] sm:ml-4 bg-white rounded fs-30w z-1">
                <span className="block px-5 py-2 sm:py-3 md:py-4 lg:py-5 xl:py-6">
                    {labels.welcome} <span>{customerName}</span>
                </span>
                <span className="border-none text-black-500 px-5 py-2 sm:py-3 md:py-4 lg:py-5 xl:py-6">
                    <span>{labels.date}</span>: {getCurrentDateTime()}
                </span>
            </div>
            <div className="bg-white flex pt-2">
                <div className='w-[33%]'>
                </div>
                <div className="w-[34%] flex justify-center">
                    <img src={customerImage} alt="Customer" className="w-24 h-24 object-cover bg-gray-300 rounded-full overflow-hidden" />
                </div>
                <div className='w-[33%] flex justify-right relative'>
                    <TextToSpeech />
                </div>
            </div>
            <div className="bg-white flex justify-center py-2 text-center z-1">
                <p className={`${customerNumber ? "block" : "hidden"}`}>{customerNumber}{" / "}{customerName}</p>
            </div>
        </>
    );
};

export default observer(Banner);
